import React from 'react';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body, Label } from '~/components/atom/Typography';
import Icon from '~/components/atom/Icon';

const ValidationMessages: React.FCC<{
  messages: Array<string>;
}> = ({ messages }) => {
  if (messages.length === 0) return null;

  return (
    <JustificationContainer align="start" gap="xxs" direction="column">
      {messages.map(message => (
        <JustificationContainer align="start" gap="xxxs" key={message}>
          <Label
            size="base"
            inline
            color={{ group: 'warning', variant: 'dark' }}
          >
            <Icon name="exclamation" />
            &nbsp;
          </Label>
          <Body
            size="base"
            margin={[null]}
            color={{ group: 'warning', variant: 'dark' }}
          >
            {message}
          </Body>
        </JustificationContainer>
      ))}
    </JustificationContainer>
  );
};

export default ValidationMessages;
